import { render, staticRenderFns } from "./DisplaceIcon.vue?vue&type=template&id=3ac54745&"
import script from "./DisplaceIcon.vue?vue&type=script&lang=js&"
export * from "./DisplaceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports